import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/server/information';

export const SERVER_MERCHANT_LIST_GET_SUCCESS = `${rootActionPath}/GET_MERCHANTS_LIST_${SUCCESS_SUFFIX}`;
export const SERVER_MERCHANT_LIST_GET_FAILURE = `${rootActionPath}/GET_MERCHANTS_LIST_${FAILURE_SUFFIX}`;
